export default "__VITE_ASSET__BNa2ySOM__"